
import { useTranslation } from 'react-i18next';

export default function TrustRiskSection() {
  const { t } = useTranslation();

  const handleClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const trustBadges = [
    {
      icon: 'ri-shield-check-line',
      title: t('common:trustRisk.badge1Title'),
      description: t('common:trustRisk.badge1Desc'),
    },
    {
      icon: 'ri-user-star-line',
      title: t('common:trustRisk.badge2Title'),
      description: t('common:trustRisk.badge2Desc'),
    },
    {
      icon: 'ri-map-2-line',
      title: t('common:trustRisk.badge3Title'),
      description: t('common:trustRisk.badge3Desc'),
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#F5F1E8]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
            <div
              className="w-full h-full rounded-full flex items-center justify-center"
              style={{
                background: 'linear-gradient(135deg, rgba(155, 35, 53, 0.1) 0%, rgba(200, 150, 12, 0.1) 100%)',
                border: '2px solid rgba(200, 150, 12, 0.3)',
              }}
            >
              <i className="ri-hand-heart-line text-3xl text-[#9B2335]"></i>
            </div>
          </div>

          <h2
            className="text-3xl md:text-4xl font-bold mb-6 text-[#8B4513]"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            {t('common:trustRisk.title')}
          </h2>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto mb-12">
            {t('common:trustRisk.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {trustBadges.map((badge, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 border-2 border-[#B8860B]/20 hover:border-[#B8860B] hover:shadow-lg transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4">
                <div
                  className="w-full h-full rounded-full flex items-center justify-center"
                  style={{
                    background: 'linear-gradient(135deg, rgba(200, 150, 12, 0.15) 0%, rgba(155, 35, 53, 0.1) 100%)',
                  }}
                >
                  <i className={`${badge.icon} text-2xl text-[#B8860B]`}></i>
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#8B4513] mb-3 text-center">
                {badge.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                {badge.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-[#F5F1E8] to-white rounded-lg p-8 border-l-4 border-[#B8860B] mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 mt-1">
              <i className="ri-lightbulb-line text-2xl text-[#B8860B]"></i>
            </div>
            <div>
              <h4 className="text-lg font-bold text-[#8B4513] mb-2">
                {t('common:trustRisk.whatYouGetTitle')}
              </h4>
              <ul className="space-y-2 text-gray-700">
                {[
                  t('common:trustRisk.item1'),
                  t('common:trustRisk.item2'),
                  t('common:trustRisk.item3'),
                  t('common:trustRisk.item4'),
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <i className="ri-check-line text-[#B8860B] mt-1 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center">
          <button
            onClick={handleClick}
            className="px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105 hover:shadow-xl"
            style={{
              background: 'linear-gradient(135deg, #7A1A28 0%, #9B2335 100%)',
              color: '#F5E6C8',
              border: '2px solid #C8960C',
              fontFamily: "'Noto Serif JP', serif",
            }}
          >
            <span className="flex items-center gap-3">
              <i className="ri-calendar-check-line text-xl"></i>
              {t('common:trustRisk.ctaButton')}
            </span>
          </button>

          <p className="mt-4 text-sm text-gray-600">
            <i className="ri-phone-line mr-2"></i>
            {t('common:trustRisk.ctaNote')}
          </p>
        </div>
      </div>
    </section>
  );
}
